var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5614",
    "data-name": "Raggruppa 5614",
    transform: "translate(-179 -272)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4178",
    "data-name": "Raggruppa 4178",
    transform: "translate(179.174 272.175)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8725",
    "data-name": "Tracciato 8725",
    d: "M11.826,0C8.614,0,8.213.015,6.951.071A8.719,8.719,0,0,0,4.08.621a5.8,5.8,0,0,0-2.1,1.362,5.774,5.774,0,0,0-1.361,2.1A8.7,8.7,0,0,0,.071,6.95C.012,8.212,0,8.614,0,11.825S.016,15.439.072,16.7a8.742,8.742,0,0,0,.549,2.871,6.016,6.016,0,0,0,3.457,3.457,8.744,8.744,0,0,0,2.871.55c1.262.061,1.664.073,4.878.073s3.614-.015,4.875-.071a8.744,8.744,0,0,0,2.871-.55,6.045,6.045,0,0,0,3.459-3.459,8.744,8.744,0,0,0,.55-2.871c.058-1.261.071-1.662.071-4.875s-.015-3.614-.071-4.875a8.744,8.744,0,0,0-.55-2.871,5.8,5.8,0,0,0-1.362-2.1,5.774,5.774,0,0,0-2.1-1.363A8.659,8.659,0,0,0,16.7.071C15.44.012,15.038,0,11.826,0m0,2.129c3.153,0,3.533.016,4.779.07a6.5,6.5,0,0,1,2.195.409A3.888,3.888,0,0,1,21.043,4.85a6.542,6.542,0,0,1,.407,2.195c.056,1.248.069,1.622.069,4.779s-.015,3.533-.073,4.779a6.65,6.65,0,0,1-.415,2.195,3.734,3.734,0,0,1-.887,1.362,3.7,3.7,0,0,1-1.362.881,6.592,6.592,0,0,1-2.2.407c-1.255.056-1.625.069-4.788.069S8.258,21.5,7,21.444a6.724,6.724,0,0,1-2.2-.412,3.681,3.681,0,0,1-1.362-.887,3.586,3.586,0,0,1-.887-1.362,6.725,6.725,0,0,1-.414-2.2c-.044-1.242-.06-1.625-.06-4.774s.017-3.529.061-4.788a6.7,6.7,0,0,1,.419-2.2A3.5,3.5,0,0,1,3.45,3.458a3.482,3.482,0,0,1,1.362-.887A6.547,6.547,0,0,1,7,2.158C8.254,2.114,8.624,2.1,11.786,2.1Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8726",
    "data-name": "Tracciato 8726",
    d: "M11.952,5.161h0A3.278,3.278,0,1,1,8.671,8.438a3.277,3.277,0,0,1,3.281-3.277h0",
    transform: "translate(-0.126 -0.075)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_8727",
    "data-name": "Tracciato 8727",
    d: "M17.8,15.6h0a6.773,6.773,0,0,1-11.774,0,.443.443,0,0,1,.108-.558,9.219,9.219,0,0,1,11.56,0,.444.444,0,0,1,.107.558",
    transform: "translate(-0.087 -0.19)",
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_5613",
    "data-name": "Raggruppa 5613",
    transform: "translate(108 40)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_4647",
    "data-name": "Raggruppa 4647",
    transform: "translate(47 42)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rettangolo_2109",
    "data-name": "Rettangolo 2109",
    width: 24,
    height: 24,
    transform: "translate(24 190)",
    fill: "none"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.ef45b5400c94ba5c50603e16946c673c.svg";
export { ForwardRef as ReactComponent };